import React, { useEffect, useState } from "react";
import Select from "../Form/Select";
import TextField from "./TextField";
import { ORIGINS } from "../../utils/constants";

type Props = any;

const SelectOrigin: React.FC<Props> = ({ name, label, control, disabled, edit, classes, setValue, value }) => {
  useEffect(() => {
    let defaultValue = ORIGINS.find(f => f.code === value);
    if (edit && defaultValue) {
      setValue('origin', { code: defaultValue?.code, label: defaultValue?.label })
    }
    setValue('originView', defaultValue?.label)
  }, [value]);

  return (
    edit ? <Select
      label={label}
      name={name}
      control={control}
      options={ORIGINS}
      disabled={disabled}
      style={{ width: '100%' }} />
      : <TextField
        label={label}
        name="originView"
        control={control}
        fullWidth
        InputLabelProps={{ shrink: true }}
        InputProps={{
          readOnly: true,
          classes: {
            input: classes.inputBlocked
          }
        }} />
  )
}

export default SelectOrigin;